import { render } from "./DisplaySettings.vue?vue&type=template&id=477d4936"
import script from "./DisplaySettings.vue?vue&type=script&lang=js"
export * from "./DisplaySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__